import Vue from 'vue';
import Cookies from 'js-cookie';

Vue.component('cookie-component', {
    data() {
        return {
            cookie: null,
            showCookieMessage: true,
        };
    },

    mounted() {
        this.cookie = Cookies.get('cookie-complience');

        if (this.cookie) {
            this.showCookieMessage = false;
        }
    },

    methods: {
        acceptCookie() {
            Cookies.set('cookie-complience', true, { expires: 30 });

            this.cookie = Cookies.get('cookie-complience');

            this.showCookieMessage = false;
        },
    },
});
